import { render, staticRenderFns } from "./PersonProfileDmRow.vue?vue&type=template&id=5de997c2&scoped=true&"
import script from "./PersonProfileDmRow.vue?vue&type=script&lang=js&"
export * from "./PersonProfileDmRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de997c2",
  null
  
)

export default component.exports